:host {
  @apply block w-full h-full;
}

::slotted(img) {
  @apply w-full min-h-full object-cover;
}

::slotted(picture) {
  @apply w-full min-h-full object-cover;
}
